import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Checkbox,
    Stepper,
    Step,
    StepButton,
    Tooltip,
    ButtonGroup,
    TextField,
    Input,
    Chip,
    MenuItem,
    ListItemIcon,
    Typography,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import _ from 'lodash';

import CSVReader from 'react-csv-reader'

import {AgricultureOutlined, AutoFixHigh, CheckBox, CheckBoxOutlineBlank, Download, DynamicForm, Engineering, FactCheck, FileOpen, LibraryAddCheck, PlayArrow, RemoveCircle, Save, Search, Settings, Warehouse } from '@mui/icons-material';

import { advance_data_entry, common_data_entry,  other_data_entry, mother_data_entry, lifetime_data_entry } from '../definitions/cow';
import { common_data_entry as cowmancommon_data_entry } from '../definitions/cowman';
import { common_data_entry as propertycommon_data_entry } from '../definitions/property';
import { useEvent } from '../context/eventContext';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { globalstyles } from '../lib/definitions';
import {  getSelectedElement, myTimestampToDate, propComparator, propComparatorDate } from '../utils/ui_utils';
import { import_cows } from '../FirebaseUtils/dbCow';
import { import_cowmans } from '../FirebaseUtils/dbCowman';
import { get_Category_list } from '../FirebaseUtils/dbCategory';
import { differenceInMonths, format } from 'date-fns';
import { ManualChooseCategory } from './ManualChooseCategory';
import SelectCategoryMenu, { CategoryMassiveChange } from '../components/menu/SelectCategoryMenu';
import { import_propertys } from '../FirebaseUtils/dbProperty';
import { getCategoryLight } from '../definitions/category';



const steps = ['caricamento file', 'selezione oggetti da importare', 'seleziona righe', 'verifica dati']
const import_element_list = [
    { id: 'cow', label: 'Soggetti' },
    { id: 'cowman', label: 'Allevatori' },
    { id: 'property', label: 'Aziende' }
]

export const ImportFileDialog = ({ cow_list }) => {
    const modalRef = useRef()
    const [open, setOpen] = useState(false);
    const { selEvent } = useEvent()
    const [raw_data, setRawData] = useState([])
    const [import_index, setImportIndex] = useState([])
    const [raw_key_data, setRawKeyData] = useState([])

    const [cowkey_data, setCowKeyData] = useState([])
    const [cowmankey_data, setCowmanKeyData] = useState([])
    const [propertykey_data, setPropertyKeyData] = useState([])

    const [activeStep, setActiveStep] = useState(0);
    const [isImporting, setIsImporting] = useState(false)
    const [isError, setIsError] = useState(false)
    const [import_section, setImportSection] = useState()
    const [trimChar, setTrimChar] = useState(2)
    const mapdatacow_dict = Object.assign({}, ...[...common_data_entry, ...advance_data_entry, ...other_data_entry, ...lifetime_data_entry, ...mother_data_entry].filter(e => e.import_id).map((x) => ({ [x.import_id]: x })))
    const mapdatacowman_dict = Object.assign({}, ...[...cowmancommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.import_id]: x })))
    const mapdataproperty_dict = Object.assign({}, ...[...propertycommon_data_entry].filter(e => e.import_id).map((x) => ({ [x.import_id]: x })))
    const [processedData, setProcessedData] = useState({ cow: [], cowman: [], property: [] })
    const [categoryList, setCategoryList] = useState([])

    const cow_list_serial_list = cow_list.map(c => c.serial)

    const onSubmit = (data, fileInof, originalFile) => {
        console.log("DATA", data)
        setRawData(data)
        const mapdatacow_key = Object.keys(mapdatacow_dict)
        const mapdatacowman_key = Object.keys(mapdatacowman_dict)
        const mapdataproperty_key = Object.keys(mapdataproperty_dict)
        if (data.length > 0) {
            setRawKeyData(Object.keys(data[0]))
            setImportIndex(Array(data.length).fill().map((x, i) => i))
            setCowKeyData(Object.keys(data[0]).filter(k => mapdatacow_key.indexOf(k) >= 0))
            setCowmanKeyData(Object.keys(data[0]).filter(k => mapdatacowman_key.indexOf(k) >= 0))
            setPropertyKeyData(Object.keys(data[0]).filter(k => mapdataproperty_key.indexOf(k) >= 0))
        } else {
            setRawKeyData([])
            setImportIndex([])
            setCowKeyData([])
            setCowmanKeyData([])
            setPropertyKeyData([])
        }
        console.log("FILEINFO", fileInof)
        console.log("originalFile", originalFile)
        setActiveStep(1)
    }

    const onError = () => {

    }

    const papaparseOptions = {
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        transformHeader: header =>
            header
                .toLowerCase()
                .replace(/\W/g, '_')
    }


    const handleClose = () => {
        setOpen(false);
    };

    const handleOpen = () => {
        setOpen(true)
        setActiveStep(0)
        setIsImporting(false)
        setRawData([])
        setImportIndex([])
        setRawKeyData([])
        setCowKeyData([])
        setImportSection(['cow', 'cowman', 'property'])
        setIsError(false)
    }




    const handleStep = (step) => () => {
        setActiveStep(step);
    };


    const handleImportSection = (e) => {
        setImportSection(s => {
            let _s = [...s]
            const c = _s.indexOf(e)
            if (c < 0) {
                _s.push(e)
            } else {
                _s.splice(c, 1)
            }
            return _s

        })
    }


    const initCategoryList = async () => {
        const cat_list = await get_Category_list(selEvent.id)
        setCategoryList(cat_list.sort(propComparator('category_number')))
    }


    useEffect(() => {
        if (activeStep === 3) {
            initCategoryList()
            let final_data_cow = []
            let final_data_cowman = []
            let final_data_property = []

            if (import_section.includes('cow')) {
                final_data_cow = _.map(import_index, _.propertyOf(raw_data))
                final_data_cow = final_data_cow.map(c => process_cowdata(c))
                final_data_cow.sort(propComparatorDate('birthdate'))
                final_data_cow.reverse()
            }
            if (import_section.includes('cowman')) {
                final_data_cowman = _.map(import_index, _.propertyOf(raw_data))
                final_data_cowman = final_data_cowman.map(c => process_cowmandata(c))
                final_data_cowman = uniqByKeepLast(final_data_cowman, c => c.cdaua_cowman)
            }
            if (import_section.includes('property')) {
                final_data_property = _.map(import_index, _.propertyOf(raw_data))
                final_data_property = final_data_property.map(c => process_propertydata(c))
                final_data_property = uniqByKeepLast(final_data_property, c => c.cdaua)

            }
            setProcessedData({
                cow: final_data_cow,
                cowman: final_data_cowman,
                cowman_dict: Object.assign({}, ...[...final_data_cowman].map((x) => ({ [x.cdaua_cowman]: x }))),
                property: final_data_property,
                property_dict: Object.assign({}, ...[...final_data_property].map((x) => ({ [x.cdaua]: x }))),
            })
        }

    }, [activeStep])


    const doImport = async () => {
        setIsImporting(true)
        const event_id = selEvent.id
        //--------import _final_data, event_id
        if (event_id) {

            const resc = await import_cowmans(event_id, processedData.cowman, [])
            console.log("RES IMPORTCM", resc)
            const cowman_dict = Object.assign({}, ...[...resc].map((x) => ({ [x.cdaua_cowman]: x })))
            const resp = await import_propertys(event_id, processedData.property, [])
            console.log("RES IMPORTPT", resp)
            const property_dict = Object.assign({}, ...[...resp].map((x) => ({ [x.cdaua]: x })))
            const processed_cows = processedData.cow.map(c => {
                console.log("import cow", c.cdaua, c.cdaua_cowman, cowman_dict[c.cdaua_cowman], property_dict[c.cdaua])
                return {
                    ...c,
                    birthdate: format(c.birthdate, 'dd/MM/yyyy'),
                    last_birthdate: format(c.last_birthdate, 'dd/MM/yyyy'),
                    cowman: cowman_dict[c.cdaua_cowman] || {},
                    property: property_dict[c.cdaua] || {}
                }
            })
            const res = await import_cows(event_id, processed_cows, ["birthdate", "last_birthdate"])
            //        const res = false
            console.log("RES IMPORT", event_id, res)
            if (res && res.length <= 0) {
                console.log("ERRORE IMPORTAZIONE")
                setIsImporting(false)
                setIsError(true)
            } else {
                //console.log("IMPORTED COW IDs: ", res)
                setOpen(false)
            }
        }
    }


    const process_cowdata = (cow) => {
        let new_cow = {}
        Object.entries(cow).filter(e => cowkey_data.includes(e[0])).map((e, k) => {
            let new_param = mapdatacow_dict[e[0]] ? mapdatacow_dict[e[0]].id : e[0]
            let value = e[1]
            if (mapdatacow_dict[e[0]] && mapdatacow_dict[e[0]].type === 'switch') {
                value = e[1]?.toLowerCase() === 'r' ? 'red' : 'black'
            }
            if (typeof value === 'string') {
                value = value.trim()
            }
            //console.log(e[0])
            if (e[0] === 'matricola') {
                let v = value
                value = v.slice(trimChar)
                new_cow['breed'] = v.slice(0,trimChar)
            }
            if (new_param === 'birthdate' || new_param === 'last_birthdate') {
                let [day, month, year] = value.split('/')
                value = new Date(+year, +month - 1, +day)
            }
            new_cow[new_param] = value
        })
        //console.log(new_cow)
        return new_cow
    }


    const process_cowmandata = (cow) => {
        let new_cowman = {}
        Object.entries(cow).filter(e => cowmankey_data.includes(e[0])).map((e, k) => {
            let new_param = mapdatacowman_dict[e[0]] ? mapdatacowman_dict[e[0]].id : e[0]
            let value = e[1]
            if (typeof value === 'string') {
                value = value.trim()
            }
            new_cowman[new_param] = value
        })
        return new_cowman
    }
    const process_propertydata = (cow) => {
        let new_property = {}
        Object.entries(cow).filter(e => propertykey_data.includes(e[0])).map((e, k) => {
            let new_param = mapdataproperty_dict[e[0]] ? mapdataproperty_dict[e[0]].id : e[0]
            let value = e[1]
            if (typeof value === 'string') {
                value = value.trim()
            }
            new_property[new_param] = value
        })
        return new_property
    }

    const getTrunkatedValue = (v) => {
        return v.slice(trimChar)
    }

    const categoryAssignament = (c, cl, i) => {
        console.log("category c", c, i)
        if (c === 1) {
            process_filter_category(i, c)
        } else if (c === 2) {
            modalRef.current.onEdit(cl, undefined, i)
        } else if (c === 3) {
            process_filter_category(i, c)
        } else if (c === 4) {
            process_filter_category(i, c)
        }
    }


    const process_filter_category = async (index_list, c) => {
        const cat_list = [...categoryList]

        const ev_date = myTimestampToDate(selEvent.event_start)
        let _c_list = [...cat_list]
        let _empty_list = []
        let _cow_list = [...processedData.cow]

        if (c === 1) {
            console.log("REMOVE")
            for (let c_i in _cow_list) {
                let cow = _cow_list[c_i]
                if (index_list.includes(parseInt(c_i))) {
                    console.log("DO REMOVE", c_i)
                    delete cow.category
                }
            }
        } else if (c === 3) {
            console.log("FROM CSV", index_list)
            for (const c_i in _cow_list) {
                if (index_list.includes(parseInt(c_i))) {
                    let cow = _cow_list[c_i]
                    console.log(c_i)
                    const cat = getSelectedElement(cow.import_category_id, _c_list, 'category_number', true)
                    console.log("DO CHANGE", cow.import_category_id, cat)
                    if (cat) {
                        cow.category = getCategoryLight(cat)
                    }else{
                        delete cow.category
                    }
                }
            }

        } else if (c === 4) {
            console.log("AUTO")
            for (let c_i in _cow_list) {
                let cow = _cow_list[c_i]
                if (index_list.includes(parseInt(c_i))) {
                    console.log("DO CHANGE", c_i)
                    const birthdate = myTimestampToDate(cow.birthdate)
                    const age = cow.birthdate ? differenceInMonths(ev_date, birthdate) : 0
                    const birth = parseInt(cow.birth)
                    let done = false
                    for (const cat of _c_list) {
                        if ((birth >= cat.cow_birth_start
                            && birth < cat.cow_birth_end)
                            && age >= cat.cow_age_months_start
                            && age < cat.cow_age_months_end
                        ) {
                            cow.category = getCategoryLight(cat)
                            if (!cat.cow_list) {
                                cat.cow_list = []
                            }
                            console.log("CATEGORY ASSIGMENT", cow)

                            //                    c.cow_list.push(cow)
                            done = true
                            break
                        }
                    }
                    if (!done) {
                        _empty_list.push(cow)
                        console.log("EMPTY", cow, birth, age)
                    }else{
                        delete cow.category
                    }
                }
            }

        }
        //setEmptyList(_empty_list)

        setCategoryList(_c_list)
        _cow_list.sort(propComparatorDate('birthdate'))
        _cow_list.reverse()
        setProcessedData(p => ({ ...p, cow: _cow_list }))
    }



    const moveCow = (cow_list, source, dest, selected_cow_index) => {
        console.log(cow_list, source, dest, selected_cow_index)
        const cat = getSelectedElement(dest, categoryList, 'id')
        setProcessedData(p => {
            let _c_list = [...p.cow]
            for (const s of selected_cow_index) {
                console.log("splice cow", cat, source, s, { ..._c_list[s], category: { category_name: cat.category_name, category_description: cat.category_description, id: cat.id } })
                _c_list.splice(s, 1, { ..._c_list[s], category: { category_name: cat.category_name, category_description: cat.category_description, id: cat.id } })
            }
            return { ...p, cow: _c_list }
        })
        /*  setCategoryList(cat_list => {
             let _c_list = [...cat_list]
             const c = checkComponentPresence(cat, _c_list, 'id')
             if (c >= 0) {
                 let _cow_list = []
                 if (_c_list[c].cow_list) {
                     _cow_list = [..._c_list[c].cow_list, ...processedData.cow.filter((c, k) => selected_cow_index.includes(k)).map(c => getCowLight(c))]
 
                 } else {
                     _cow_list = [...processedData.cow.filter((c, k) => selected_cow_index.includes(k)).map(c => getCowLight(c))]
                 }
                 _c_list.splice(c, 1, { ..._c_list[c], cow_list: _cow_list })
             }
             return _c_list
 
 
 
         }) */


    }


    return (
        <div>
            <MenuItem onClick={handleOpen} disableRipple>
                <ListItemIcon>
                    <FileOpen />
                </ListItemIcon>
                Importa da CSV
            </MenuItem>


            <Dialog open={open} onClose={handleClose} fullScreen={true}>
                <DialogTitle>
                    Importa soggetti da file CSV
                    <Stepper activeStep={activeStep} disabled={isImporting} >
                        {steps.map((label, index) => {
                            const stepProps = { completed: false }
                            const labelProps = { optional: false };
                            return (
                                <Step key={index} {...stepProps} onClick={handleStep(index)}>
                                    <StepButton onClick={handleStep(index)} {...labelProps}>{label}</StepButton>
                                </Step>
                            );
                        })}
                    </Stepper>
                    {activeStep === 0 &&
                        <><Button startIcon={<Download />} target="_blank" href={"../template_soggetti_gara.csv"}>Scarica template CSV per importazione</Button></>
                    }
                    {activeStep === 1 &&
                        raw_key_data.length > 0 &&
                        <Grid>

                            <Grid spacing={1} container sx={{ borderBottom: '1px solid black', fontSize: '0.7em', backgroundColor: 'lightgrey' }}>
                                <Grid size={1} justifyContent={"baseline"} alignSelf={"end"}>
                                    Campo dal file
                                </Grid>
                                <Grid size={1} color="primary">
                                    oggetti da importare
                                </Grid>
                                {console.log("IMPORT SECTION", import_section)}
                                {import_element_list.map((e, k) => (
                                    <Grid key={k} size={3}>
                                        <Button fullWidth key={k} onClick={() => handleImportSection(e.id)} variant={import_section.includes(e.id) ? 'contained' : 'outlined'} startIcon={import_section.includes(e.id) ? <CheckBox /> : <CheckBoxOutlineBlank />}>{e.label}</Button>
                                        <Grid container sx={{ backgroundColor: import_section.includes(e.id) ? 'lightgreen' : '' }}>
                                            <Grid size={1}>
                                            </Grid>
                                            <Grid size="grow">
                                                Campo da sistema
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    }
                    {activeStep === 2 &&
                        <>
                            <Grid>
                                {isError && <Box sx={{ color: 'red' }}>Errore importazione</Box>}
                            </Grid>
                            <Grid container sx={{ pb: 0.5 }}>
                                <span style={globalstyles.input_label}>
                                    numero di caratteri da rimuovere dall'inizio della matricola: &nbsp;
                                </span>
                                <Input variant="outlined" value={trimChar} onChange={(e) => setTrimChar(e.target.value)} />
                            </Grid>
                        </>
                    }
                    {activeStep === 3 &&
                        <>
                            {categoryList.length === 0 &&
                                <Typography sx={globalstyles.missing_value}>
                                    Nessuna categoria ancora inserita. Sarà necessario associare successivamente (dopo l'importazione) le categorie ai singoli soggetti.
                                </Typography>}
                        </>
                    }
                </DialogTitle>
                <DialogContent sx={{ mt: 1 }}>
                    {activeStep === 0 &&
                        <Box sx={{ textAlign: 'center' }}>
                            <CSVReader
                                cssClass="csv-reader-input"
                                label="Seleziona file CSV"
                                onFileLoaded={onSubmit}
                                onError={onError}
                                parserOptions={papaparseOptions}
                                inputId="csv_file"
                                inputName="csv_file"
                                inputStyle={{ color: 'red' }}
                            />
                        </Box>
                    }
                    {activeStep === 1 &&
                        raw_key_data.map((kd, k) => (
                            <Grid key={k} spacing={1} container sx={{ borderBottom: '1px solid black' }}>
                                <Grid size={2}>
                                    {kd}
                                </Grid>
                                <Grid container size={3} sx={{ backgroundColor: import_section.includes('cow') && cowkey_data.includes(kd) ? 'lightgreen' : '#eee' }}>
                                    <Grid size={1}>
                                        {cowkey_data.includes(kd) &&
                                            <CheckBox />
                                        }
                                    </Grid>
                                    <Grid size={"grow"}>
                                        {mapdatacow_dict[kd]?.label}
                                    </Grid>
                                </Grid>
                                <Grid container size={3} sx={{ backgroundColor: import_section.includes('cowman') && cowmankey_data.includes(kd) ? 'lightgreen' : '#eee' }}>
                                    <Grid size={1}>
                                        {cowmankey_data.includes(kd) &&
                                            <CheckBox />
                                        }
                                        {/*                                        <Checkbox
                                            size="small"
                                            checked={cowmankey_data.includes(kd)}
                                            name={kd}
                                            disabled={!import_section.includes('cowman')}
                                            onChange={(ev) => onChangeCowmanKey(ev.target)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        /> */}
                                    </Grid>
                                    <Grid size={"grow"}>
                                        {mapdatacowman_dict[kd]?.label}
                                    </Grid>
                                </Grid>
                                <Grid container size={3} sx={{ backgroundColor: import_section.includes('property') && propertykey_data.includes(kd) ? 'lightgreen' : '#eee' }}>
                                    <Grid size={1}>
                                        {propertykey_data.includes(kd) &&
                                            <CheckBox />
                                        }
                                        {/*                                        <Checkbox
                                            size="small"
                                            checked={propertykey_data.includes(kd)}
                                            name={kd}
                                            disabled={!import_section.includes('property')}
                                            onChange={(ev) => onChangepropertyKey(ev.target)}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        /> */}
                                    </Grid>
                                    <Grid size={"grow"}>
                                        {mapdataproperty_dict[kd]?.label}
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}



                    {activeStep === 2 &&

                        <Grid>
                            <DataGrid
                                rows={raw_data.map((r, k) => ({ ...r, id: k }))}
                                rowHeight={25}
                                columns={Object.entries(raw_data[0]).filter(e => cowkey_data.indexOf(e[0]) >= 0).map(e => {
                                    if (e[0] === 'matricola') {
                                        return {
                                            field: e[0],
                                            label: e[0],
                                            renderCell: (params) => {
                                                if (cow_list_serial_list.includes(params.value)) {
                                                    return (
                                                        <Tooltip title={`matricola già presente nell'evento: ${params.value}`} placement='left'>
                                                            <span className="table-cell-trucate"> {getTrunkatedValue(params.value)}</span>
                                                        </Tooltip>

                                                    )
                                                } else {
                                                    return (
                                                        <Tooltip title={params.value} arrow placement='left'>
                                                            <span className="table-cell-trucate">{getTrunkatedValue(params.value)}</span>
                                                        </Tooltip>
                                                    )
                                                }
                                            }
                                        }
                                    } else {
                                        return { field: e[0], label: e[0] }
                                    }
                                })
                                }
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 25,
                                        },
                                    },
                                }}
                                sx={{
                                    [`.${gridClasses.cell}.duplicate`]: {
                                        backgroundColor: 'red',
                                        color: '#1a3e72',
                                    },
                                }}
                                getCellClassName={(params) => {
                                    if (params.field === 'matricola' && cow_list_serial_list.includes(params.value)) {
                                        return 'duplicate'
                                    }
                                    return '';
                                }}
                                pageSizeOptions={[25]}
                                checkboxSelection
                                onRowSelectionModelChange={(r) => {
                                    setImportIndex(r)
                                }}
                                rowSelectionModel={import_index}
                                disableRowSelectionOnClick
                                disableColumnFilter
                                disableColumnSorting
                                disableColumnMenu
                            />

                        </Grid>
                    }
                    {activeStep === 3 &&
                        <>
                            <ManualChooseCategory moveCow={moveCow} category_list={categoryList.sort(propComparator('category_number'))} ref={modalRef} />
                            <ResultSection processedData={processedData} categoryAssignament={categoryAssignament} categoryList={categoryList.sort(propComparator('category_number'))} />
                        </>
                    }


                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} disabled={isImporting} onClick={handleClose}>Chiudi</Button>
                    {activeStep === 1 &&
                        <Button variant="contained" loading={false} onClick={() => setActiveStep(activeStep + 1)} startIcon={<PlayArrow />}>passo Successivo</Button>
                    }
                    {activeStep === 2 &&
                        <Button variant="contained" loading={false} onClick={() => setActiveStep(activeStep + 1)} startIcon={<PlayArrow />}>passo Successivo</Button>
                    }
                    {activeStep === 3 &&
                        <Button variant="contained" onClick={doImport} disabled={isImporting} loadingPosition="start" loading={isImporting} startIcon={<PlayArrow />}>Importa {import_index.length}/{raw_data.length}</Button>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
}




const ResultSection = ({ processedData, categoryAssignament, handleMove, categoryList }) => {
    const [showSection, setShowSection] = useState('cow')
    const [selected_cow_index, setSelectedCowIndex] = useState([])
    const [filterCategory, setFilterCategory] = useState(0)


    const toggleSelect = (index) => {
        setSelectedCowIndex(c => {
            let _c = [...c]
            const k = _c.indexOf(index)
            if (k < 0) {
                _c.push(index)
            } else {
                _c.splice(k, 1)
            }
            return _c
        })
    }
    const selectAll = () => {
        setSelectedCowIndex(processedData.cow.map((c, k) => k))
    }

    const selectNone = () => {
        setSelectedCowIndex([])
    }

    const selectEmpty = () => {
        setSelectedCowIndex(processedData.cow.map((item, index) => ({ item, index })).filter(c => c.item.category === undefined || c.item.category.id === undefined).map(c => c.index))
    }

    const selectFilter = () => {
        setSelectedCowIndex(processedData.cow.map((item, index) => ({ item, index })).filter(c =>
            filterCategory === 0
            || (filterCategory === -1 && !c.item.category)
            || (c.item.category && filterCategory === c.item.category.id)

        ).map(c => c.index))
    }

    const handleFilterCategory = (c) => {
        setFilterCategory(c)
    }




    const handleCategoryAssignament = (c) => {
        categoryAssignament(c, processedData.cow.filter((item, index) => selected_cow_index.includes(index)), selected_cow_index)
        setSelectedCowIndex([])
    }

    return (

        <Box>
            <Grid container spacing={1}>
                <Grid>
                    Visualizza liste finali
                </Grid>
                <ButtonGroup size="small">
                    {import_element_list.map((e, k) => (
                        <Button color="secondary" key={k} onClick={() => setShowSection(e.id)} variant={showSection === e.id ? 'contained' : 'outlined'}>{e.label}<Chip size="small" label={processedData[e.id].length} /> </Button>
                    ))}
                </ButtonGroup>
            </Grid>
            {showSection === 'cowman' &&
                <Grid >
                    {processedData.cowman.sort(propComparator('name')).map((c, k) => (
                        <Grid key={k} container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.6em' }}>
                            <Grid size="grow">
                                {c.name}
                            </Grid>
                            {Object.entries(c).filter(e => e[0] !== 'name').map((e, ek) => (
                                <Grid size="grow" key={ek}>
                                    {e[1]}
                                </Grid>
                            ))}
                        </Grid>
                    ))}
                </Grid>
            }
            {showSection === 'property' &&
                <Grid >
                    {processedData.property.sort(propComparator('name')).map((c, k) => (
                        <Grid key={k} container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.6em' }}>
                            <Grid size="grow">
                                {c.name}
                            </Grid>
                            {Object.entries(c).filter(e => e[0] !== 'name').map((e, ek) => (
                                <Grid size="grow" key={ek}>
                                    {e[1]}
                                </Grid>
                            ))}
                        </Grid>
                    ))}
                </Grid>
            }
            {showSection === 'cow' &&
                <Grid >
                    <Grid container>
                        {/*                     <Grid size="auto">
                            <ButtonGroup>
                                <Button onClick={() => setShowAdvanceData(a => !a)}>dati avanzati</Button>
                            </ButtonGroup>

                        </Grid> */}
                        <Grid size={"grow"}>
                            <ButtonGroup size="small" color="light">
                                <Tooltip title="deseleziona tutti" arrow>
                                    <Button onClick={selectNone} startIcon={<CheckBoxOutlineBlank />}></Button>
                                </Tooltip>
                                <Tooltip title="seleziona soggetti senza categoria" arrow>
                                    <Button onClick={selectEmpty} startIcon={<DynamicForm />}>{processedData.cow.filter(c => c.category === undefined || c.category.id === undefined).length}</Button>
                                </Tooltip>
                                <Tooltip title="seleziona soggetti filtrati" arrow>
                                    <Button onClick={selectFilter} startIcon={<FactCheck />}></Button>
                                </Tooltip>
                                <Tooltip title="seleziona tutti i soggetti" arrow>
                                    <Button onClick={selectAll} startIcon={<LibraryAddCheck />}>{processedData.cow.length}</Button>
                                </Tooltip>
                            </ButtonGroup>
                        </Grid>
                        <Grid size="grow">
                            <CategoryMassiveChange handleChoose={handleCategoryAssignament} cow_count={selected_cow_index.length} />
                        </Grid>
                        <Grid size="auto">
                            <SelectCategoryMenu options={[
                                { id: 0, category_name: 'VISUALIZZA TUTTI', category_description: '', cow_list: processedData.cow },
                                { id: -1, category_name: 'senza categoria', category_description: '', cow_list: processedData.cow.filter(c => c.category === undefined || c.category.id === undefined) },
                                ...categoryList.map(c => ({ ...c, cow_list: processedData.cow.filter(cow => cow.category && cow.category.id === c.id) }))
                            ]} handleChoose={handleFilterCategory} />
                        </Grid>
                    </Grid>
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size={0.5}>
                        </Grid>
                        <Grid size="grow">
                            Matricola
                        </Grid>
                        <Grid size="grow">
                            Nascita
                        </Grid>
                        <Grid size={1}>
                            età
                        </Grid>
                        <Grid size={1}>
                            # parti
                        </Grid>
                        <Grid size={1}>
                        </Grid>
                        <Grid size="grow">
                            ultimo parto
                        </Grid>
                        <Grid size="grow">
                            categoria assegnata
                        </Grid>

                    </Grid>
                    {processedData.cow.map((cow, k) => {
                        if (filterCategory === 0
                            || (filterCategory === -1 && !cow.category)
                            || (cow.category && filterCategory === cow.category.id)
                        ) {
                            return <OneCow
                                cow={cow}
                                key={k}
                                index={k}
                                property={processedData.property_dict[cow.cdaua]}
                                cowman={processedData.cowman_dict[cow.cdaua_cowman]}
                                toggleSelect={toggleSelect}
                                is_selected={selected_cow_index.includes(k)}
                            />
                        }
                        return <></>
                    }
                    )}
                </Grid>
            }
        </Box>
    )


}




const OneCow = memo(({ cow, toggleSelect, is_selected, index, cowman, property }) => {
    const birthdate = myTimestampToDate(cow.birthdate)
    return (
        <Grid container spacing={1} sx={{ ...globalstyles.list_row, ...globalstyles.elem_row }}>
            {toggleSelect &&
                <Grid size={0.5}>
                    <Button variant={is_selected ? 'contained' : 'outlined'} onClick={() => toggleSelect(index)} size="small" >{is_selected ? <CheckBox sx={{ fontSize: 15 }} /> : <CheckBoxOutlineBlank sx={{ fontSize: 15 }} />}</Button>
                </Grid>
            }
            <Grid size="grow">
                {cow.serial}
            </Grid>

            <Grid size="grow" sx={{ overflow: 'clip' }}>
                {format(birthdate, 'dd/MM/yyyy')}
            </Grid>
            <Grid size={1}>
                {differenceInMonths(new Date(), birthdate)}
            </Grid>
            <Grid size={1}>
                {cow.birth}
            </Grid>
            <Grid size={1}>
                {cowman && <Tooltip title={<>allevatore: <br /><b>${cowman.name}</b></>}><AgricultureOutlined /></Tooltip>}
                {property && <Tooltip title={<>azienda: <br /><b>${property.name}</b></>}><Warehouse /></Tooltip>}
            </Grid>
            <Grid size="grow">
                {cow.birth > 0 ?
                    cow.last_birthdate ?
                        format(cow.last_birthdate, 'dd/MM/yyyy')
                        : 'data ultimo parto mancante'
                    : <></>
                }
            </Grid>
            <Grid size="grow" sx={{ fontSize: '0.8em' }}>
                {cow.category &&
                    <>
                        <Box sx={{ fontWeight: 'bold' }}>
                            {cow.category.category_name}
                        </Box>
                        <Box>
                            {cow.category.category_description}

                        </Box>
                    </>}
            </Grid>
        </Grid>
    )
})




function uniqByKeepLast(data, key) {
    return [
        ...new Map(
            data.map(x => [key(x), x])
        ).values()
    ]
}